/* tslint:disable */
/* eslint-disable */
/**
 * Spotnana API documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Alliance preferences.
 * @export
 * @interface AlliancePref
 */
export interface AlliancePref {
    /**
     * 
     * @type {Array<string>}
     * @memberof AlliancePref
     */
    alliances: Array<AlliancePrefAlliancesEnum>;
}

/**
    * @export
    * @enum {string}
    */
export enum AlliancePrefAlliancesEnum {
    UnknownAlliance = 'UNKNOWN_ALLIANCE',
    StarAlliance = 'STAR_ALLIANCE',
    Oneworld = 'ONEWORLD',
    Skyteam = 'SKYTEAM',
    Unrecognized = 'UNRECOGNIZED'
}



